import Mixin from "../index.js"
import bigDataTitleImage from '@/assets/images/大数据OPSbanner.png';
import aiTitleImage from '@/assets/images/AI OPS banner.png';
import iotTitleImage from '@/assets/images/IoT OPS banner.png';


import dataOps1 from '@/assets/images/超大规律 分布式计算能力.png';
import dataOps2 from '@/assets/images/PB级-分布式存储能⼒.png';
import dataOps3 from '@/assets/images/字段级 加解密和授权 安全管控能⼒.png';
import dataOps4 from '@/assets/images/全⾯、⾼可⽤-数据中台体系.png';
import dataOps5 from '@/assets/images/⾼覆盖度的 ⽤户理解体系及知识图谱能⼒.png';
import dataOps6 from '@/assets/images/icon丰富易⽤的 可视化平台.png';

import AIOps1 from '@/assets/images/易⽤的可视化机器学习建模.png'
import AIOps2 from '@/assets/images/全生命周期模型管理.png';
import AIOps3 from '@/assets/images/丰富的模型市场和组件市场.png'
import AIOps4 from '@/assets/images/超⼤规模的机器学习模型训练.png'
import AIOps5 from '@/assets/images/⾼效的机器学习模型推理能⼒.png'

import IotOps1 from '@/assets/images/领先的IOT平台化能力.png'
import IotOps2 from '@/assets/images/领先的区块链模式物联⽹和边缘计算能⼒.png'
import IotOps3 from '@/assets/images/⾼效的边缘计算能⼒.png'
import IotOps4 from '@/assets/images/全⾯的云边端协同计算能⼒.png'

import marketOps1 from '@/assets/images/线上线下营销触达能力.png'
import marketOps2 from '@/assets/images/海量⼴告创意管理.png'
import marketOps3 from '@/assets/images/毫秒级⼴告投放能⼒.png'
import marketOps4 from '@/assets/images/秒级⼈群创建与洞察.png'
import marketOps5 from '@/assets/images/准确、⾼效、易⽤的决策分析支撑.png'

import recommendationOps1 from '@/assets/images/精准的个性化推荐能力.png'
import recommendationOps2 from '@/assets/images/TB级样本数据、百亿特征的超大规模推荐模型.png'
import recommendationOps3 from '@/assets/images/百毫秒级响应的高性能推荐服务能力.png'
import recommendationOps4 from '@/assets/images/灵活开放的推荐平台化能力.png'



export default {
  mixins: [Mixin],
  data() {
    return {
      data: {
        BigDataOps: {
          title: 'Data OPS',
          subTitle: '云上数据管家, 让企业享受数据红利',
          text: 'Data OPS以开放接口及高度可视化服务\n为用户提供全球领先的超大规模计算和数据中台体系\n解决数据爆炸时代针对超大规模数据量的分布式计算、存储、数据全生命周期管理的问题',
          backgroundClass: 'BD-background',
          
          advantages: '六大优势',
          abilities: '三项技术能力',
          solutions: '两个场景',
          
          advantagesTitle: '集IoT、数据可视化于一体的云上大数据管家',
          advantagesList: [
            {img: dataOps1, text: '超大规模\n分布式计算能力'},
            {img: dataOps2, text: 'PB级\n分布式存储能力'},
            {img: dataOps3, text: '字段级\n加解密和授权\n安全管控能力'},
            {img: dataOps4, text: '全面、高可用\n数据中台体系'},
            {img: dataOps5, text: '高覆盖度的\n用户理解体系及知识图谱能力'},
            {img: dataOps6, text: '丰富易用的\n可视化平台'},
          ],
          
          abilitiesList: [
            {title: '数据聚合/处理/交换能力', abilities: ['数十种数据源接入组件，可限流配置', '数十种数据处理组件，可配置多线程并行处理', '数十种外部系统数据交换组件',
                                                '支持可视化拖拉方式构建数据接入、处理、交换的Pipeline']},
            {title: '超大规模数据计算能力', abilities: ['容器化计算任务调度能力，支持主流算法计算引擎', '高效的计算资源利用率，CPU计算资源利用率超过80%，GPU利用率超70%',
                                              'EB级数据存储能力']},
            {title: '数据工作流', abilities: ['支持构建体系化数据资产管理体系及通用/领域知识图谱', '构建千人千面用户画像及内容理解体系']},
          ],
          solutionsList: [
            {title: '数字城市', text: '超大规模城市数据汇聚和分析管理平台'},
            {title: '数字教育', text: '教育行业数据汇聚、处理、分析、挖掘的平台\n提供丰富的数据透视和可视化能力'},
          ],
          solutionImages: ['bigDataSolution-1', 'bigDataSolution-2'],
        },
        AIOps: {
          title: 'AI OPS',
          subTitle: '系统化解决企业智能管理痛点, 无处不智能',
          text: 'AI OPS提供高效易用的机器学习建模能力及丰富的模型市场和组件市场能力\n解决机器学习模型的复用和产品化问题。致力于打造全球领先的AI建模平台\n解决企业智能化需求中的关键问题: 快速可视化建模、超大规模模型训练、高效模型推理',
          backgroundClass: 'AI-background',
  
          advantages: '五大优势',
          abilities: '六项技术能力',
          solutions: '两个场景',
  
          advantagesTitle: '集IoT、数据可视化于一体的云上大数据管家，赋能企业迈入数字经济时代',
          advantageClass: 'vstack',
          advantagesList: [
            {img: AIOps1, text: '易用的可视化机器学习模型'},
            {img: AIOps2, text: '全生命周期模型管理'},
            {img: AIOps3, text: '丰富的模型市场和组件市场'},
            {img: AIOps4, text: '超大规模的机器学习模型训练'},
            {img: AIOps5, text: '高效的机器学习模型推理能力'},
          ],
          abilitiesList: [
            {title: '一站式AI模型开发/部署/运维', abilities: ['图形化拖拽式构建机器学习Pipeline', '机器学习任务/服务容器化调度，支持自动弹性扩缩容']},
            {title: '超大规模机器学习模型训练', abilities: ['1000+的大规模集群联合训练', '支持AutoML自动建模能力']},
            {title: '高效机器学习模型推理', abilities: ['针对不同平台优化的机器学习模型推理']},
            {title: '云边端联动建模/推理能力', abilities: ['支持云端模型自动下发，端上模型热更新']},
            {title: '组件/模型市场能力', abilities: ['实现算法可复用、可共享，提升算法开发效率']},
            {title: 'laas层解耦，云存储产品全适配', abilities: ['适配各大云厂商存储产品，支持多种数据源：HDFS、Hive、MySQL、对象存储、Kafka']},
          ],
          solutionsList: [
            {title: '数字城市', text: '超大规模城市数据AI模型的训练和推理'},
            {title: '数字教育', text: '教育行业智能化服务的支持\n如：学生照片分拣、人脸识别门禁等'},
          ],
          solutionImages: ['aiSolution-1', 'aiSolution-2'],
        },
        IotOps: {
          title: 'IoT OPS',
          subTitle: '让设备上云, 智连万物, 打造“数字经济时代”地基',
          text: '行业领先的物联网和边缘计算平台\n完善稳定的物联网设备接入、管理能力, 平台化服务模式、结合区块链技术增强物联网安全性\n高性能的边缘计算和云边协同计算能力, 提供智慧城市大规模边缘视频计算服务',
          backgroundClass: 'IoT-background',
  
          advantages: '四大优势',
          abilities: '六项技术能力',
          solutions: '三个场景',
  
          advantagesTitle: '四大优势支撑亿级设备部署',
          advantageClass: 'twoItemPerRow',
          advantagesList: [
            {img: IotOps1, text: '领先的IoT平台化能力\n支持亿级设备接入'},
            {img: IotOps2, text: '领先的区块链模式物联网和边缘计算能力,\n提升接入性能和安全性能'},
            {img: IotOps3, text: '高效的边缘计算能力,\n支持1000个以上的边缘网关节点调度和计算'},
            {img: IotOps4, text: '全面的云边端协同计算能力,\n支持千万级别的云边端网络协同计算'},
          ],
          abilitiesList: [
            {title: '设备管理', abilities: ['设备接入提供多种异构网络协议和异构数据格式的支持', '设备监控提供超大规模数量的设备在线管理和监控运维的能力']},
            {title: '规则引擎', abilities: ['规则引擎提供设备数据转发至不同接收目标的能力，包括：时序数据库、机器学习、流式处理、对象存储和关系型存储等']},
            {title: '数据分析', abilities: ['数据分析提供丰富的IoT数据可视化组件，辅助设备的监控分析和管理']},
            {title: '边缘计算', abilities: ['边缘计算提供针对边缘设备集群的计算、存储、调度三大能力']},
            {title: '服务型设备接入', abilities: ['支持各种服务器数据的接入支持（Kafka、mysql等）']},
            {title: '终端数据采集', abilities: ['支持采集终端和Web端的页面数据和用户行为数据的能力，SDK形式多样，包括：Android、iOS、JavaScript、小程序等']},
          ],
          solutionsList: [
            {title: '数字城市-人脸识别门禁', text: '人脸检测和人脸比对算法智能识别各类人员'},
            {title: '数字城市-视频边缘计算', text: '边缘端多路摄像头的视频分析'},
            {title: '工业物联网', text: '工业设备监控和异样检测'},
          ],
          solutionImages: ['iotSolution-1', 'iotSolution-2', 'iotSolution-3'],
        },
        MarketingOps: {
          title: 'MKT OPS',
          subTitle: '精细化运营，智慧型驱动，数字化增长',
          text: 'MKT OPS提供高可用的营销触达能力以及丰富的广告创意管理能力，\n实现毫秒级广告投放能力以及秒级人群创建与洞察。\n致力于打造全流程多渠道的精准营销平台，帮助企业实现完整的营销闭环：用户洞察、用户定向、渠道投放、效果回流',
          backgroundClass: 'Marketing-background',
  
          advantages: '五大优势',
          abilities: '四项技术能力',
          solutions: '三个场景',
  
          advantagesTitle: '融合AI+IoT能力打造线上线下营销闭环',
          advantageClass: 'vstack',
          advantagesList: [
            {img: marketOps1, text: '线上线下营销触达能力'},
            {img: marketOps2, text: '海量广告创意管理'},
            {img: marketOps3, text: '毫秒级广告投放能力'},
            {img: marketOps4, text: '秒级人群创建与洞察'},
            {img: marketOps5, text: '准确、高效、易用的决策分析支撑'},
          ],
          abilitiesList: [
            {title: '用户透视', abilities: ['强大的标签系统，多维度绘制目标人群全貌特征，清晰呈现用户的行为轨迹、兴趣偏好，深入透视关联因素']},
            {title: '人群定向', abilities: ['提供海量的基础数据、优质的用户资源，根据人口属性和兴趣倾向特征，灵活地筛选人群，自由组合，lookalike一键智能扩散']},
            {title: '多渠道投放', abilities: ['一站式大规模自动化管理微信、短信、App推送、邮件等不同营销触点，分析不同渠道人群特征和数量分布，制定独特的投放计划']},
            {title: '效果优化', abilities: ['打通各渠道营销效果数据，实现数据回流与归一，提供不同场景下的指标优化方法，人群、创意、效果等多方面指导']},
          ],
          solutionsList: [
            {title: '数字教育'},
            {title: '数字旅游'},
            {title: '数字医疗'},
          ],
          solutionImages: ['Marketing-1', 'Marketing-2', 'Marketing-3'],
        },
        RecommendationOps: {
          title: 'Rcmd OPS',
          subTitle: '智能推荐, 你见即你想',
          text: 'Rcmd OPS提供灵活开放的推荐平台化能力、百毫秒级别响应的高性能推荐服务能力，\n致力于打造全球领先的推荐引擎，解决企业商品和用户之间的最佳匹配问题，\n将企业的商品推荐给最感兴趣和最合适的用户，实现用户“千人千面”的自动化、实时、个性化精准推荐',
          backgroundClass: 'Recommendation-background',
  
          advantages: '四大优势',
          abilities: '六项技术能力',
          solutions: '四个场景',
  
          advantagesTitle: 'AI+大数据支持企业个性化定制推荐系统',
          advantageClass: 'twoItemPerRow',
          advantagesList: [
            {img: recommendationOps1, text: '精准的个性化推荐能力\n冷启动用户CTR超过5%'},
            {img: recommendationOps2, text: 'TB级别样本数据、\n百亿特征的超大规模推荐模型训练能力'},
            {img: recommendationOps3, text: '百毫秒级别响应的高性能推荐服务能力'},
            {img: recommendationOps4, text: '灵活开放的推荐平台化能力'},
          ],
          abilitiesList: [
            {title: '多模态、多目标精准推荐', abilities: ['多模态：自动关联、融合图像、音视频、文本数据进行联合建模，精准理解内容', '多目标：支持多种推荐目标（点击率、转化率、浏览时长等）的联合建模、推荐效果整体提升']},
            {title: '毫秒级高可用推荐服务', abilities: ['毫秒级反馈推荐效果，极致用户体验', '容器化技术快速部署，动态调整实例数，实现服务高并发、低时延7*24小时自动监控，零运维成本']},
            {title: '一站式推荐全流程闭环', abilities: ['覆盖推荐模型训练、模型服务化、A/B Test、推荐效果反馈闭环全流程一站式自动化服务，5min从零构建推荐系统']},
            {title: '实时用户/商品画像更新', abilities: ['秒级更新用户/商品画像、召回候选集自动内容审核，帮助企业有效规避风险覆盖多维度用户画像，有效解决冷启动问题']},
            {title: '全自动特征工程与模型构建', abilities: ['自动特征选择', '自动机器建模']},
            {title: '海量数据实时处理与深度学习', abilities: ['超大规模实时数据处理与深度学习能力接受海量用户行为数据流，挖掘用户实时兴趣，构建深度学习模型实现用户与商品的动态精准匹配，有效提升业务指标']},
          ],
          solutionsList: [
            {title: '电商推荐'},
            {title: '金融推荐'},
            {title: '新闻资讯推荐'},
            {title: '短视频推荐'},
          ],
          solutionImages: ['Recommendation-1', 'Recommendation-2', 'Recommendation-3', 'Recommendation-4'],
        },
  
        contentTop: 100,
      }
    };
  },
  computed: {
    nowOps() {
      return this.data[this.$route.name];
    },
    isBigDataOps() {
      return this.$route.name === 'BigDataOps';
    },
    isAIOps() {
      return this.$route.name === 'AIOps';
    },
    isIotOps() {
      return this.$route.name === 'IotOps';
    },
    isMarketOps() {
      return this.$route.name === 'MarketingOps';
    },
    isRecommendationOps() {
      return this.$route.name === 'RecommendationOps';
    },
  },
};
